import { last } from 'lodash';
import {
  ALLOWED_ATTACHMENT_MIME_TYPES,
  BLOCKED_ATTACHMENT_EXTENSIONS,
  IAttachmentValidationResult,
  MAX_ATTACHMENT_SIZE_BYTES,
} from '@principle-theorem/ng-interactions';

export interface IReferralAttachmentMetadata {
  name: string;
  size: number;
  contentType: string;
}

export function validateReferralAttachment(
  media: IReferralAttachmentMetadata
): IAttachmentValidationResult {
  const fileSizeInMB = media.size / (1024 * 1024);
  if (media.size > MAX_ATTACHMENT_SIZE_BYTES) {
    return {
      valid: false,
      reason: `File size exceeds the maximum allowed size of 10 MB. Your file is ${fileSizeInMB.toFixed(2)} MB.`,
    };
  }

  const parts = media.name.split('.');
  const extension = last(parts);
  if (parts.length < 2 || !extension) {
    return {
      valid: false,
      reason: `File must have a file extension.`,
    };
  }

  const fileExtension = '.' + extension.toLowerCase();
  if (BLOCKED_ATTACHMENT_EXTENSIONS.includes(fileExtension)) {
    return {
      valid: false,
      reason: `File type ${fileExtension} is not allowed. Please use a different file format.`,
    };
  }

  if (!ALLOWED_ATTACHMENT_MIME_TYPES.includes(media.contentType)) {
    return {
      valid: false,
      reason: `File type is not supported. Allowed types: PDF, Word, Excel, images (JPEG, PNG, GIF, WebP), text, and CSV files.`,
    };
  }

  return { valid: true };
}
